import { createReducer, on } from '@ngrx/store';
import { Holder } from '../../models/holder.model';
import * as HoldersActions from './holders.actions';
import { PaginationState } from '../../models/stock.model';

export interface HoldersState {
  holders: Holder[];
  selectedHolder: Holder | null;
  loading: boolean;
  error: any;
  pagination: PaginationState;
}

export const initialState: HoldersState = {
  holders: [],
  selectedHolder: null,
  loading: false,
  error: null,
  pagination: {
    currentPage: 1,
    pageSize: 20,
    totalItems: 0,
  },
};

export const holdersReducer = createReducer(
  initialState,

  // Load Holders
  on(HoldersActions.loadHolders, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(HoldersActions.loadHoldersSuccess, (state, { holders, pagination }) => ({
    ...state,
    holders,
    pagination,
    loading: false,
    error: null,
  })),
  on(HoldersActions.loadHoldersFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // Load Single Holder
  on(HoldersActions.loadHolder, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(HoldersActions.loadHolderSuccess, (state, { holder }) => ({
    ...state,
    selectedHolder: holder,
    loading: false,
    error: null,
  })),
  on(HoldersActions.loadHolderFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // Create Holder
  on(HoldersActions.createHolder, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(HoldersActions.createHolderSuccess, (state, { holder }) => ({
    ...state,
    holders: [...state.holders, holder],
    loading: false,
    error: null,
  })),
  on(HoldersActions.createHolderFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // Update Holder
  on(HoldersActions.updateHolder, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(HoldersActions.updateHolderSuccess, (state, { holder }) => ({
    ...state,
    holders: state.holders.map((h) => (h.id === holder.id ? holder : h)),
    selectedHolder: holder,
    loading: false,
    error: null,
  })),
  on(HoldersActions.updateHolderFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // Delete Holder
  on(HoldersActions.deleteHolder, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(HoldersActions.deleteHolderSuccess, (state, { id }) => ({
    ...state,
    holders: state.holders.filter((h) => h.id !== id),
    loading: false,
    error: null,
  })),
  on(HoldersActions.deleteHolderFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  }))
);
